import React from "react";
import { connect } from "react-redux";
import _ from "lodash";

import { Plus2ReportAdmin } from "./Plus2ReportAdmin";
import { Plus2ReportPolice } from "./Plus2ReportPoliceStation";

class TwoPlusCom extends React.Component {
  constructor(props) {
    super(props);
    this.myTableRef = React.createRef();
  }
  state = {
    loading: false,
    downloadLoding: false,
    report_4_startDate: "",
    report_4_endDate: "",
    report4_loader: false,
    report4_List: [],
    report4_List1: [],
    report4_List_Total: 0,
    report4_API_loader: false,
    totalCriminal: 0,
    crimeTitle: "",
    setCriminalViewModel: false,
    PlusViewForm_List: [],
    report_type: null,
    newArophiData: [],
    arophiCount: [],
    arophiListCount: [],
    arophiList: [],
    historyCount: [],
    historyList: [],
    showList: "सांख्यिकी",
    showModal: false,
    download: "",
    filter: "",
  };

  downloadReport = () => {
    const { download } = this.state;
    if (download == "excel") {
      this.download_csv();
    }
    if (download == "pdf") {
      this.handleDownload();
    }
  };
  componentDidMount() {
    const { user } = this.props;
    if (user && user.role !== "4") {
      this.setState({ showList: "यादी" });
    }
  }

  render() {
    const { user } = this.props;
    console.log("user", user);

    return (
      <>
        {user.role === "2" && <Plus2ReportPolice />}

        {["4", "9", "10", "12"].includes(user.role) && <Plus2ReportAdmin />}
      </>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  return {
    user,
    users,
    professionals,
  };
}

const connectedTwoPlus = connect(mapStateToProps)(TwoPlusCom);
export { connectedTwoPlus as TwoPlus };
